import PropTypes from 'prop-types';

const Details = ({ children, className, summaryText, ...props }) => {
    return (
        <details className="govuk-details" {...props}>
            <summary className="govuk-details__summary">
                <span className={`govuk-details__summary-text ${className}`}>
                    {summaryText}
                </span>
            </summary>
            <div className={`govuk-details__text ${className}`}>
                {children}
            </div>
        </details>
    );
};

Details.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    summaryText: PropTypes.string.isRequired
};

Details.defaultProps = {
    className: ''

};

export default Details;
